import { ChangeUserLockType } from "../../types/Auth";
import { patch } from "../../utils/axios-config";
import { AUTH_LOCK } from "../../utils/constants";

export const changeUserLock = async (data: ChangeUserLockType) => await patch<ChangeUserLockType, string>(AUTH_LOCK, data);